export default "__VITE_ASSET__CXvFjFMY__"